import * as React from "react";

import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import {
  getRoutingReasonLine,
  messageNotificationPatientId
} from "features/inbox/text-routing/routing-reason.util";
import useTextsNotDeliveredEnabled from "features/inbox/texts-not-delivered/use-texts-not-delivered-enabled.hook";
import useTextRoutingEnabled from "hooks/use-text-routing-enabled.hook";
import {
  MessageNotification,
  isSmsNotDeliveredExtra
} from "services/types/notifications";

import MessageNotificationLink from "./message-notification-link.component";
import SmsNotDeliveredNotification from "./sms-not-delivered-notification.component";

const MessageNotificationComponent = (notification: MessageNotification) => {
  const { title, description, extra } = notification;
  // Patient text routing: "why this reached you". Notifications without a
  // `routing_reason` (all pre-feature ones) get no line and render as before.
  const { isFlagOn } = useTextRoutingEnabled();
  // Texts not delivered: a staff-typed text that failed gets its own row. With
  // the flag off it renders as the plain MESSAGE row below, title + description.
  const isTextsNotDeliveredOn = useTextsNotDeliveredEnabled();
  const reasonLine = isFlagOn ? getRoutingReasonLine(extra) : null;

  if (isTextsNotDeliveredOn && isSmsNotDeliveredExtra(extra)) {
    return <SmsNotDeliveredNotification {...notification} extra={extra} />;
  }

  return (
    <ListItemText
      primary={
        <MessageNotificationLink
          to={`/inbox/${messageNotificationPatientId(extra) ?? ""}`}
          style={{ display: "flex", flex: 1 }}
        >
          {title}
        </MessageNotificationLink>
      }
      secondary={
        reasonLine ? (
          <>
            <Typography
              component="span"
              variant="body2"
              color="text.secondary"
              data-testid="message-notification-reason"
              sx={{ display: "block", mb: 0.25 }}
            >
              {reasonLine}
            </Typography>
            <Typography
              variant="body1"
              component="span"
              sx={{ display: "block" }}
            >
              {description}
            </Typography>
          </>
        ) : (
          <Typography variant="body1">{description}</Typography>
        )
      }
    />
  );
};

export default MessageNotificationComponent;
